var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  ご購入いただくためには"+_vm._s(_vm.hostName)+"の会員登録が必要です。すでに"+_vm._s(_vm.hostName)+"に登録済みの方はログインしてください。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }